// Template Generated by DataExtraction.py at 1716507313

import EnglishMat3 from "../../Forms/KYC2/English_Mat-3.png";
import EnglishMat3Labels from "../../Labels/KYC2/English_Mat-3.json";
import FrenchMat3 from "../../Forms/KYC2/French_Mat-3.png";
import FrenchMat3Labels from "../../Labels/KYC2/French_Mat-3.json";
import {
    drawTextOnLabel,
    drawWhiteBox,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
} from "../../PDFGenerationUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";
import {
    calculateTotalInvestmentAssets,
    calculateTotalOtherAssets,
} from "../../../Utils/KYCUtils";
import {
    PLAN_TYPE_IDS,
    calculateLifetimeDepositAmount,
    calculateYearlyDepositAmount,
} from "../../../Utils/PlanUtils";

const HIDE_GROUP_BOX = { x: 16.46, y: 10.99, width: 174.68, height: 68.55 };
const HIDE_ACHIEVERS_BOX = {
    x: 16.46,
    y: 78.99,
    width: 174.68,
    height: 71.55,
};
const HIDE_SI_BOX = { x: 16.46, y: 149.99, width: 174.68, height: 71.55 };

const HIDE_GROUP_CONTRIBUTIONS = { x: 16.46, y: 62.99, width: 174.68, height: 16.55 }
const HIDE_SI_CONTRIBUTIONS = { x: 16.46, y: 205.99, width: 174.68, height: 17.55 };
const HIDE_ACHIEVERS_CONTRIBUTIONS = {
    x: 16.46,
    y: 133.99,
    width: 174.68,
    height: 16.55,
};

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchMat3Labels : EnglishMat3Labels;
    const formImage = isFrench ? FrenchMat3 : EnglishMat3;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    const kyc = data.knowYourClient;
    const plan = data.plan;

    const liquidAssets = Number(kyc.cashAndLiquid) || 0;
    const investableAssets = calculateTotalInvestmentAssets(kyc) || 0;
    const illiquidAssets = calculateTotalOtherAssets(kyc) || 0;

    let contribution =
        plan.depositMode === "T"
            ? calculateLifetimeDepositAmount(data, true, true)
            : calculateYearlyDepositAmount(data, true, true);
    contribution = Number(contribution) || 0;

    const formatPct = (contribution, assets) => {
        if (!contribution || !assets) return "0.00%";
        return ((Number(contribution) / assets) * 100).toFixed(2) + "%";
    };

    drawText(kyc.riskProfileConclusion || "", "riskProfileConclusion");
    drawLongText(kyc.whyPlanIsSuitable || "", "whyPlanIsSuitable");
    drawLongText(kyc.notes || "", "notes");

    if (plan.planTypeID === 0) {
        // Group
        fillCheckbox(
            kyc.groupRecommendationConsiderObjectivesAndTime,
            "groupRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(
            kyc.groupAbilityToMeetRequirements,
            "groupAbilityToMeetRequirements",
        );
        fillCheckbox(kyc.groupReviewedFees, "groupReviewedFees");
        fillCheckbox(kyc.groupConsideredAchievers, "groupConsideredAchievers");
        fillCheckbox(kyc.groupConsideredSI, "groupConsideredSI");
        fillCheckbox(
            kyc.groupRecommendationConsidersRisk,
            "groupRecommendationConsidersRisk",
        );
        fillCheckbox(
            kyc.groupConfirmedAbilityToMeetContributions,
            "groupConfirmedAbilityToMeetContributions",
        );
        fillCheckbox(
            kyc.groupConfirmedWillingness,
            "groupConfirmedWillingness",
        );
        drawLongText(
            kyc.groupAlternativeNotSelectedDescription || "",
            "groupAlternativeNotSelectedDescription",
        );
        drawLongText(
            kyc.groupWhyPutsInterestFirst || "",
            "groupWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "groupPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "groupTModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "groupContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "groupContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "groupOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "groupContributionAsPercentOfLiquid",
        // );
    } else if (plan.planTypeID === 1) {
        // SI
        fillCheckbox(
            kyc.SIRecommendationConsiderObjectivesAndTime,
            "SIRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(kyc.SIReviewedFees, "SIReviewedFees");
        fillCheckbox(
            kyc.SIRecommendationConsidersRisk,
            "SIRecommendationConsidersRisk",
        );
        fillCheckbox(kyc.SINeedForFlexibility, "SINeedForFlexibility");
        fillCheckbox(kyc.SIConfirmedWillingness, "SIConfirmedWillingness");
        drawLongText(
            kyc.SIAlternativeNotSelectedDescription || "",
            "SIAlternativeNotSelectedDescription",
        );
        fillCheckbox(kyc.SIConsideredGroup, "SIConsideredGroup");
        fillCheckbox(kyc.SIConsideredAchievers, "SIConsideredAchievers");
        drawLongText(
            kyc.SIWhyPutsInterestFirst || "",
            "SIWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "SIPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "SITModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "SIContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "SIContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "SIOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "SIContributionAsPercentOfLiquid",
        // );
    } else if (plan.planTypeID === 2) {
        // Achievers
        fillCheckbox(
            kyc.achieversRecommendationConsiderObjectivesAndTime,
            "achieversRecommendationConsiderObjectivesAndTime",
        );
        fillCheckbox(
            kyc.achieversConfirmedReasonablenessOfContribution,
            "achieversConfirmedReasonablenessOfContribution",
        );
        fillCheckbox(kyc.achieversReviewedFees, "achieversReviewedFees");
        fillCheckbox(kyc.achieversConsideredGroup, "achieversConsideredGroup");
        fillCheckbox(kyc.achieversConsideredSI, "achieversConsideredSI");
        fillCheckbox(
            kyc.achieversRecommendationConsidersRisk,
            "achieversRecommendationConsidersRisk",
        );
        fillCheckbox(
            kyc.achieversConfirmedWillingness,
            "achieversConfirmedWillingness",
        );
        drawLongText(
            kyc.achieversAlternativeNotSelectedDescription || "",
            "achieversAlternativeNotSelectedDescription",
        );
        drawLongText(
            kyc.achieversWhyPutsInterestFirst || "",
            "achieversWhyPutsInterestFirst",
        );
        // drawText(plan.depositMode || "", "achieversPlanMode");
        // drawText(
        //     plan.depositMode === "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "achieversTModeContribution",
        // );
        // drawText(
        //     formatPct(contribution, illiquidAssets),
        //     "achieversContributionAsPercentOfIlliquid",
        // );
        // drawText(
        //     formatPct(contribution, investableAssets),
        //     "achieversContributionAsPercentOfInvestable",
        // );
        // drawText(
        //     plan.depositMode !== "T"
        //         ? displayCurrency(contribution, i18n.language)
        //         : "",
        //     "achieversOtherModesAnnualContribution",
        // );
        // drawText(
        //     formatPct(contribution, liquidAssets),
        //     "achieversContributionAsPercentOfLiquid",
        // );
        fillCheckbox(
            kyc.achieversNeedForFlexibility,
            "achieversNeedForFlexibility",
        );
    }

    drawWhiteBox(
        doc,
        HIDE_ACHIEVERS_CONTRIBUTIONS.x,
        HIDE_ACHIEVERS_CONTRIBUTIONS.y,
        HIDE_ACHIEVERS_CONTRIBUTIONS.width,
        HIDE_ACHIEVERS_CONTRIBUTIONS.height,
    );

    drawWhiteBox(
        doc,
        HIDE_SI_CONTRIBUTIONS.x,
        HIDE_SI_CONTRIBUTIONS.y,
        HIDE_SI_CONTRIBUTIONS.width,
        HIDE_SI_CONTRIBUTIONS.height,
    );

    drawWhiteBox(
        doc,
        HIDE_GROUP_CONTRIBUTIONS.x,
        HIDE_GROUP_CONTRIBUTIONS.y,
        HIDE_GROUP_CONTRIBUTIONS.width,
        HIDE_GROUP_CONTRIBUTIONS.height,
    );

    // Keep only the selected plan section visible.
    if (plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        drawWhiteBox(
            doc,
            HIDE_ACHIEVERS_BOX.x,
            HIDE_ACHIEVERS_BOX.y,
            HIDE_ACHIEVERS_BOX.width,
            HIDE_ACHIEVERS_BOX.height,
        );
        drawWhiteBox(
            doc,
            HIDE_SI_BOX.x,
            HIDE_SI_BOX.y,
            HIDE_SI_BOX.width,
            HIDE_SI_BOX.height,
        );
    } else if (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        drawWhiteBox(
            doc,
            HIDE_GROUP_BOX.x,
            HIDE_GROUP_BOX.y,
            HIDE_GROUP_BOX.width,
            HIDE_GROUP_BOX.height,
        );
        drawWhiteBox(
            doc,
            HIDE_SI_BOX.x,
            HIDE_SI_BOX.y,
            HIDE_SI_BOX.width,
            HIDE_SI_BOX.height,
        );
    } else if (plan.planTypeID === PLAN_TYPE_IDS.SI) {
        drawWhiteBox(
            doc,
            HIDE_GROUP_BOX.x,
            HIDE_GROUP_BOX.y,
            HIDE_GROUP_BOX.width,
            HIDE_GROUP_BOX.height,
        );
        drawWhiteBox(
            doc,
            HIDE_ACHIEVERS_BOX.x,
            HIDE_ACHIEVERS_BOX.y,
            HIDE_ACHIEVERS_BOX.width,
            HIDE_ACHIEVERS_BOX.height,
        );
    }
};

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    let signers = [];
    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
